export interface ContractData {
  id?:string;
  customerName: string;
  invoiceAddress: string;
  startDate: string;
  endDate: string;
  note: string;
  interval: string;
  priceIncludeVat: boolean;
  insurancePercent: string;
  invoiceDetails: string;
  useUnitsForInvoiceValue: boolean;
  rate: string;
  per: string;
  invoiceDetailsRate: string;
  listAssignedUnitsOnInvoice: boolean;
  paymentMethod: string;
}

export interface StorageRow {
  id: string;
  name?: string;
  site_name?: string;
  type?: string;
  site_type?: string;
  totalUnits: number;
  availableUnits: number;
}

export interface UnitRow {
  id: string;

  site_id: string;
  unit_type_id: string;

  unit_ref_id: string;
  unit_number?: number;

  status?: string;

  unit_type_name?: string;
  storage_type?: string;

  size_ft3?: string;

  unit_width?: string;
  unit_length?: string;
  unit_height?: string;

  rent_type?: string;

  prefix?: string;

  price_per_unit?: string;

  site_access_hours?: string;

  access_start_time?: string | null;
  access_end_time?: string | null;

  security_deposit_type?: string;
  security_deposit_value?: string;

  created_at?: string;
  updated_at?: string;

  // ============================================================
  // Temporary / contract assignment fields
  // ============================================================

  in?: string;
  inTime?: string;

  out?: string;
  outTime?: string;

  inDate?: string;
  outDate?: string;
  rentType?: string;
  pricePerUnit?: string;
  provisional?: boolean;

  invoicedUpTo?: string | null;
  invoicedUpto?: string | null;

  invoiceLineDescription?: string;
}

export interface ContractUnit {
  unitId: string;

  unitRefId?: string;
  unitTypeName?: string;
  storageType?: string;
  sizeFt3?: string;

  pricePerUnit?: string;
  rentType?: string;

  inDate: string;
  inTime: string;

  outDate: string;
  outTime: string;

  provisional: boolean;

  invoicedUpto: string | null;

  invoiceLineDescription?: string;
}

export interface SelectedSite {
  siteId: string;

  siteName?: string;
  siteType?: string;

  units: ContractUnit[];
}

export const STEPS = ["Create a Contract", "Select Storage", "Select Unit"];
